var map = {
	"./amex.png": 87889,
	"./diners.png": 36306,
	"./discover.png": 37435,
	"./jcb.png": 54000,
	"./mastercard.png": 61802,
	"./unionpay.png": 27548,
	"./unknown.png": 23404,
	"./visa.png": 98540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54238;